import React from 'react'

import PropTypes from 'prop-types'

import { useT } from '@galo-monitor/i18n'
import { arrowDown } from '@galo-monitor/icons'
import { colors } from '@galo-monitor/styles'
import Icon from '@galo-monitor/web-components/Icon'

import IconButton from '../IconButton'

const ArrowDownIconButton = ({ iconColor, ...props }) => {
  const t = useT()
  return (
    <IconButton tooltip={ t('expand') } { ...props }>
      <Icon icon={ arrowDown } color={ iconColor } />
    </IconButton>
  )
}

ArrowDownIconButton.propTypes = {
  iconColor: PropTypes.string
}

ArrowDownIconButton.defaultProps = {
  iconColor: colors.mutedText
}

export default ArrowDownIconButton
